import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: 2,
    width: '100%'
  },
  col: {
    flex: 1,
    minWidth: 0
  },
  label: {
    display: 'inline-block',
    marginBottom: '4px'
  },
  select: {
    width: '100%'
  },
  menuPaper: {
    maxHeight: 240
  }
});
